__turbopack_context__.v({
  "disabled": "field-footer-module-scss-module__9QMWYq__disabled",
  "footer": "field-footer-module-scss-module__9QMWYq__footer",
  "icon": "field-footer-module-scss-module__9QMWYq__icon",
  "placeholder": "field-footer-module-scss-module__9QMWYq__placeholder",
});
